import { render } from "./User_Rights.vue?vue&type=template&id=6342fbd4"
import script from "./User_Rights.vue?vue&type=script&lang=js"
export * from "./User_Rights.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__